module.exports = require('../dist/vue-i18n.prod.cjs')